import ResultTypes from 'app/login/ResultTypes';

export const isValidLogin = result => result === ResultTypes.IS_VALID_LOGIN;
export const isLocked = result => result === ResultTypes.IS_LOCKED;
export const is2FARequired = result => result === ResultTypes.IS_2FA_REQUIRED;
export const isSingleSessionRequired = result =>
  result === ResultTypes.IS_SINGLE_SESSION;
export const isMissingCsrf = result => result === ResultTypes.IS_MISSING_CSRF;
export const isValidCode = result => result === ResultTypes.IS_VALID_CODE;
export const isSent = result => result === ResultTypes.IS_SENT;
export const isReset = result => result === ResultTypes.IS_RESET;
export const isBadCredentials = result =>
  result === ResultTypes.IS_BAD_CREDENTIALS;
